export const convertObjectsToSelectOption = <T extends { id: number | string; name: string }>(objects: T[]) =>
  objects.map(({ id, name }) => ({ value: id, label: name }));
